<template>
  <div>
    <v-row dense>
      <v-col md="12" cols="12">
        <v-card flat dense>
          <v-toolbar dense dark color="primary">
            <v-toolbar-title><h5 class="font-weight-light">SPORO TRANSACTION SECTION</h5>
            </v-toolbar-title>
            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
<!--            <strong>-->
<!--              <h3 class="font-weight-light">Fund Balance: {{ formatPrice(fund_balance)-->
<!--                }}</h3>-->
<!--            </strong>-->
            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
            <strong>
              <h3 class="font-weight-light">Overall Transaction: {{ formatPrice(balance_format)
                }}</h3>
            </strong>
          </v-toolbar>
          <v-card-text>
            <v-row dense class="mt-4">
              <v-col md="3" cols="12">
                <v-select
                  class="mx-2"
                  :items="fund_option_items"
                  label="Option"
                  item-value="option"
                  item-text="option"
                  required
                  :rules="rules.combobox_rule"
                  v-model="option"
                  dense
                  @change="reset"
                ></v-select>
              </v-col>
              <v-col md="3" cols="12" v-if="option!=''">
                <v-select
                  class="mx-2"
                  :items="fund_category_items"
                  item-value="category"
                  item-text="category"
                  label="Category"
                  required
                  :rules="rules.combobox_rule"
                  v-model="category"
                  dense
                  @change="reset"
                ></v-select>
              </v-col>
              <v-col md="6" cols="12" v-if="option!=''">
                <v-select
                  class="mx-2"
                  :items="fund_particulars_items"
                  item-value="particulars"
                  item-text="particulars"
                  label="Particulars"
                  required
                  :rules="rules.combobox_rule"
                  v-model="particulars"
                  dense
                  @change="reset"
                ></v-select>
              </v-col>
              <v-col md="12" cols="12">
                <payment-sections v-on:data="on_save"
                                  :category="category"
                                  :option="option"
                                  :particulars="particulars"
                                  :ref_no="reference_no"
                                  :fund_particulars_id="fund_particulars_id"
                                  :fund_particulars_pricing="fund_particulars_pricing"
                ></payment-sections>
              </v-col>

              <v-col md="12" cols="12">
                <h2>Liquidations Data</h2>
                <payments-data v-on:data="on_save"
                               :liquidations="fund_items"></payments-data>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import {mdiAccountSearchOutline} from '@mdi/js'
  import {mapGetters, mapActions} from 'vuex'
  import PaymentSections
    from '@/views/liquidations/sporo_fund_liquidations/SporoFundLiquidationSections'
  import PaymentsData from '@/views/liquidations/sporo_fund_liquidations/SporoFundLiquidationData'

  const initialState = () => {
    return {
      payment_for_data: [],

      balance_format: 0,
      fund_balance: 0,

      fund_items: [],
      option: '',
      category: '',
      reference_no: '',
      particulars: '',
      fund_option_items: [],
      fund_particulars_items: [],
      fund_category_items: [],
      fund_particulars_pricing: [],
      is_have_client: false,

      fund_particulars_id: 0,
    }
  }

  export default {
    components: {
      PaymentSections,
      PaymentsData,
    },
    setup() {
      return {
        icons: {
          mdiAccountSearchOutline,
        },
      }
    },
    data() {
      return initialState()
    },
    created() {
      this.initialize_data()
    },
    computed: {
      ...mapGetters('form_rules', ['rules']),
      ...mapGetters('authentication', ['branch_id', 'user_id', 'month_of']),
    },
    methods: {
      ...mapActions('fund_liquidation', ['get_liquidation']),
      ...mapActions('fund_particulars', ['get_particulars_active']),

      formatPrice(value) {
        let val = (value / 1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      initialize_data() {
        const data = new FormData()
        data.append('branch_id', this.branch_id)
        data.append('month_of', this.month_of)
        this.get_liquidation(data)
          .then(response => {
            this.fund_items = response.data[0].data
            this.balance_format = response.data[0].balance
            this.fund_balance = response.data[0].fund_balance
          })
          .catch(error => {
            console.log(error)
          })
        this.get_particulars_active(data)
          .then(response => {
            this.fund_option_items = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },
      reset() {
        this.fund_particulars_pricing = []
        if (this.fund_option_items.length > 0) {
          var index = this.fund_option_items
            .map(function (x) {
              return x.option
            })
            .indexOf(this.option)
          if (index >= 0) {
            this.fund_category_items = this.fund_option_items[index].data
          }
        }
        if (this.fund_category_items.length > 0) {
          var index = this.fund_category_items
            .map(function (x) {
              return x.category
            })
            .indexOf(this.category)
          if (index >= 0) {
            this.fund_particulars_items = this.fund_category_items[index].data
          }
        }
        if (this.fund_particulars_items.length > 0) {
          var index = this.fund_particulars_items
            .map(function (x) {
              return x.particulars
            })
            .indexOf(this.particulars)
          if (index >= 0) {
            this.fund_particulars_id = this.fund_particulars_items[index].id
            this.fund_particulars_pricing = this.fund_particulars_items[index].pricing
          }
        }
      }
      ,
      on_save(value) {
        if (value) {
          Object.assign(this.$data, initialState())
          this.initialize_data()
        }
      }
    },
  }
</script>

<style lang="scss">
  @import '~@/plugins/vuetify/default-preset/preset/misc.scss';
</style>
